import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {
    Button,
    Card, 
    CardActionArea,
    CardActions,
    CardContent,
    Grid,
    Typography
} from '@material-ui/core'; 

const useStyles = makeStyles({
    root: {
        // maxWidth: 345,
    },
});

const SchoolListItem = (props) => {

    const classes = useStyles();

    return (
        <>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <Card className={classes.root}>
                    <CardActionArea>
                        {/* <CardMedia
                            component="img"
                            alt="Contemplative Reptile"
                            height="140"
                            image={props.banner}
                            title="Contemplative Reptile"
                        /> */}
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                {props.schoolName}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                {props.description}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                    <CardActions>
                        <Button size="small" color="primary">
                            Share
                        </Button>
                        <Button size="small" color="primary">
                            Learn More
                        </Button>
                    </CardActions>
                </Card>
            </Grid>
        </>  
    );
}

export default SchoolListItem;